import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EyebrowProps {
    children: ReactNode
    tone?: 'forest' | 'muted' | 'light'
    className?: string
}

const tones = {
    forest: 'text-forest',
    muted: 'text-muted-foreground',
    light: 'text-cream/80'
}

// Small letter-spaced label that sits above section headings
export const Eyebrow: FC<EyebrowProps> = ({ children, tone = 'forest', className }): ReactNode => {
    return (
        <p className={cn('inline-flex items-center gap-3 text-[0.6875rem] font-medium uppercase tracking-[0.3em]', tones[tone], className)}>
            <span aria-hidden='true' className='h-px w-8 bg-current opacity-50' />
            {children}
        </p>
    )
}
